import React, { useState, useEffect, useRef } from 'react'
import { Tabs, Card, Popover, Button, Input, Space } from 'antd'
import { InfoCircleOutlined, FilterFilled, SearchOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import {
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initValueAndLabel,
  uniqueFun,
  isChineseFun,
  dateFormatYearMonthDay,
  numFormat
} from '@/utils/common'
import {
  getAccuracySummaryQuery,
  exportAccuracySummaryPage,
  exportNoUpcMisMatchReport
} from '@/services/rfid/reports/operationAccuracySummary'
import { getSiteTypeOrNameOrPlant } from '@/services/rfid/rfidConfig/rfidStore'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
const startMonth = dayjs().subtract(1, 'day')
const endMonth = dayjs().subtract(1, 'day')
const OperationAccuracySummary = () => {
  let deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [tabActive, setTabActive] = useState('1')
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [paginationAsn, setPaginationAsn] = useState(paginationInit)
  const [paginationDn, setPaginationDn] = useState(paginationInit)
  const [filtersAsnObj, setFiltersAsnObj] = useState({
    number: []
  })
  const [filtersDnObj, setFiltersDnObj] = useState({
    number: []
  })
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.plant',
      key: 'plants',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.operationAccuracySummary.searchDate',
      key: 'rangeDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg =
          current &&
          current >
            dayjs()
              .subtract(1, 'day')
              .endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const handleSearch = confirm => {
    mounting.current = true
    confirm()
  }
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
      return (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
          <Input
            size="small"
            placeholder={`${formatMessageNew('languageObj.commonLocale.placeholderInput')} ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(confirm)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(confirm, selectedKeys, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
            >
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button onClick={() => clearFilters && clearFilters()} size="small">
              {formatMessageNew('languageObj.commonLocale.clear')}
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close()
              }}
            >
              {formatMessageNew('languageObj.commonLocale.close')}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: filtered => (
      <FilterFilled
        style={{
          color: filtered ? '#0958d9' : '#1677ff'
        }}
      />
    )
  })
  const tableColumnsAsn1 = [
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.asn'),
      dataIndex: 'number',
      width: 120,
      fixed: 'left',
      ...getColumnSearchProps('asn')
      // filteredValue: filtersAsnObj.number || []
    },
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.asnQty'),
      dataIndex: 'qty',
      width: 100,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    }
  ]
  const tableColumnsDn1 = [
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.dn'),
      dataIndex: 'number',
      width: 120,
      fixed: 'left',
      ...getColumnSearchProps('dn')
      // filteredValue: filtersDnObj.dn || []
    },
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.giQty'),
      dataIndex: 'qty',
      width: 100,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    }
  ]
  const tableColumns2 = [
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.noScan'),
      dataIndex: 'noScanQty',
      width: 100,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.unitScanAccurate'),
      dataIndex: 'unitScanAccurate',
      children: [
        {
          title: () => formatMessageNew('languageObj.operationAccuracySummary.qty'),
          dataIndex: 'accuracyQty',
          width: 100,
          render: text => {
            return <div>{numFormat(text)}</div>
          }
        },
        {
          title: () => formatMessageNew('languageObj.operationAccuracySummary.accuracyRate'),
          dataIndex: 'accuracyRate',
          width: 100,
          render: text => {
            return <div>{text}</div>
          }
        }
      ]
    },

    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.upcMissed'),
      dataIndex: 'missedQty',
      width: 100,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.upcExceeded'),
      dataIndex: 'exceededQty',
      width: 100,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.overallUpcMismatch'),
      dataIndex: 'overAllMismatchQty',
      width: 120,
      render: text => {
        return <div>{numFormat(text)}</div>
      }
    }
  ]
  const tableColumnsAsn3 = [
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.noAsnUpcMismatch'),
      dataIndex: 'noAsnMismatchQty',
      width: 120,
      render: (text, record) => {
        return text > 0 ? (
          <div
            className="link_name"
            onClick={() => {
              exportNoUpcMisMatchReportFun(record)
            }}
          >
            {numFormat(text)}
          </div>
        ) : (
          <div>{numFormat(text)}</div>
        )
      }
    }
  ]
  const tableColumnsDn3 = [
    {
      title: () => formatMessageNew('languageObj.operationAccuracySummary.noDnUpcMismatch'),
      dataIndex: 'noAsnMismatchQty',
      width: 120,
      render: (text, record) => {
        return text > 0 ? (
          <div
            className="link_name"
            onClick={() => {
              exportNoUpcMisMatchReportFun(record)
            }}
          >
            {numFormat(text)}
          </div>
        ) : (
          <div>{numFormat(text)}</div>
        )
      }
    }
  ]
  const exportNoUpcMisMatchReportFun = record => {
    const params = {
      ...record,
      type: tabActive,
      ...isChineseFun()
    }
    exportNoUpcMisMatchReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const [tableColumnsAsn] = useState([...tableColumnsAsn1, ...tableColumns2, ...tableColumnsAsn3])
  const [tableColumnsDn] = useState([...tableColumnsDn1, ...tableColumns2, ...tableColumnsDn3])
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectOptions = () => {
    Promise.all([getSiteTypeOrNameOrPlant({ type: 3 })]).then(res => {
      if (res && res.length > 0) {
        searchListInit.forEach(itemFirst => {
          const arr = []
          if (itemFirst.key === 'plants') {
            const records = res[0].resultData || []
            for (let index = 0; index < records.length; index++) {
              const element = records[index]
              arr.push(element)
            }
            itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
          }
        })
        setSearchList([...searchListInit])
      }
    })
  }

  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    exportAccuracySummaryPage(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...getPaginationValues(),
      currentPage: 1
    }
    getPaginationFun(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    const pg = {
      ...getPaginationValues(),
      currentPage: 1
    }
    getPaginationFun(pg)
    setQueryFlag(!queryFlag)
  }
  const getPaginationValues = () => {
    return tabActive === '1' ? paginationAsn : paginationDn
  }
  const getPaginationFun = params => {
    if (tabActive === '1') {
      setPaginationAsn(params)
    } else {
      setPaginationDn(params)
    }
  }
  const getTableFilterValues = () => {
    let val = tabActive === '1' ? filtersAsnObj.number : filtersDnObj.number
    if (val && val.length > 0) {
      val = val[0].split(',')
    }
    return val
  }
  const getTableFilterFun = params => {
    return tabActive === '1' ? setFiltersAsnObj(params) : setFiltersDnObj(params)
  }
  const handleTableChange = (pagina, filters) => {
    mounting.current = true
    const params = {
      ...getPaginationValues(),
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    getTableFilterFun(filters)
    getPaginationFun({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate } = info
    const params = {
      ...info,
      numbers: getTableFilterValues(),
      type: tabActive,
      startDate: formatStartTime(rangeDate),
      endDate: formatEndTime(rangeDate)
    }
    delete params.rangeDate
    return params
  }
  const searchDataFun = () => {
    let pgObj = getPaginationValues()
    const params = {
      pageNo: pgObj.currentPage,
      size: pgObj.pageSize,
      ...getParams()
    }

    getAccuracySummaryQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pgObj,
        total: dt.total
      }
      getPaginationFun(pg)
    })
  }

  const tabChange = e => {
    setTabActive(e)
    setQueryFlag(!queryFlag)
  }
  const tabItems = [
    {
      key: '1',
      label: formatMessageNew('languageObj.operationAccuracySummary.byASN'),
      children: (
        <AntdTable
          rowKey={record => record.id}
          // 独一无二的表示，不能重复
          columnsKey="columns_accuracySummaryByASN"
          onDownload={downLoadFun}
          optStyle={{ top: -30 - deviceSize * 20 }}
          dataSource={tableList}
          columns={tableColumnsAsn}
          pagination={paginationAsn}
          onChange={handleTableChange}
        />
      )
    },
    {
      key: '2',
      label: formatMessageNew('languageObj.operationAccuracySummary.byDN'),
      children: (
        <AntdTable
          rowKey={record => record.id}
          // 独一无二的表示，不能重复
          columnsKey="columns_accuracySummaryByDN"
          onDownload={downLoadFun}
          optStyle={{ top: -30 - deviceSize * 20 }}
          dataSource={tableList}
          columns={tableColumnsDn}
          pagination={paginationDn}
          onChange={handleTableChange}
        />
      )
    }
  ]
  const getPopoverContent = () => {
    return (
      <div>
        <div
          className="tagTypeVal"
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.operationAccuracySummary.definition1') }}
        ></div>
        <div className="tagTypeVal mt10">{formatMessageNew('languageObj.operationAccuracySummary.definition2')}</div>
        <div
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.operationAccuracySummary.definition3') }}
        ></div>
        <div className="tagTypeVal mt10">{formatMessageNew('languageObj.operationAccuracySummary.definition4')}</div>
        <div
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.operationAccuracySummary.definition5') }}
        ></div>
      </div>
    )
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={false}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container pt0">
          <Tabs
            activeKey={tabActive}
            onChange={tabChange}
            items={tabItems}
            tabBarExtraContent={{
              left: (
                <Popover
                  trigger="click"
                  color="#f5f5f5"
                  className="mr10 cursorPointer"
                  overlayStyle={{ maxWidth: '75vw', height: '95vh', overflow: 'auto' }}
                  placement="right"
                  content={getPopoverContent()}
                >
                  <InfoCircleOutlined />
                  {/* {formatMessageNew('languageObj.rfidOutboundScanReport.dataDefinition')} */}
                </Popover>
              )
            }}
          />
        </div>
      </Card>
    </div>
  )
}
export default OperationAccuracySummary
